import React from "react";
import { alpha } from "@mui/material/styles";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import colors from "../../assets/theme/colors";

const ImportHistoryLibraryLink = () => {
  const navigate = useNavigate();
  return (
    <Paper variant="outlined" sx={{ p: 1.25, borderRadius: "14px", bgcolor: alpha(colors.semantic.sageMist, 0.35) }}>
      <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "center" }} justifyContent="space-between" spacing={1}>
        <Box>
          <Typography sx={{ fontSize: "0.88rem", fontWeight: 850 }}>Import care history</Typography>
          <Typography sx={{ fontSize: "0.78rem", color: alpha(colors.semantic.ink, 0.66) }}>Upload document batches, continue reviews, and see past imports.</Typography>
        </Box>
        <Button onClick={() => navigate("/import-history")} sx={{ flexShrink: 0, textTransform: "none", fontWeight: 800 }}>Open Import History</Button>
      </Stack>
    </Paper>
  );
};

export default ImportHistoryLibraryLink;
